// extracted by mini-css-extract-plugin
module.exports = {"modal":"BeginReview-module_modal_2LoEl"};